<template>
  <div>
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M16 8.5C16 12.9183 12.4183 16.5 8 16.5C3.58172 16.5 0 12.9183 0 8.5C0 4.08172 3.58172 0.5 8 0.5C12.4183 0.5 16 4.08172 16 8.5ZM9 4.5C9 5.05228 8.55228 5.5 8 5.5C7.44772 5.5 7 5.05228 7 4.5C7 3.94772 7.44772 3.5 8 3.5C8.55228 3.5 9 3.94772 9 4.5ZM7 7.5C6.44772 7.5 6 7.94772 6 8.5C6 9.05229 6.44772 9.5 7 9.5V12.5C7 13.0523 7.44772 13.5 8 13.5H9C9.55228 13.5 10 13.0523 10 12.5C10 11.9477 9.55228 11.5 9 11.5V8.5C9 7.94772 8.55228 7.5 8 7.5H7Z"
        fill="#60A5FA"
      />
    </svg>
  </div>
</template>

<script>
export default {
  name: 'ArrowIcon',
};
</script>
